// removed by extract-text-webpack-plugin
module.exports = {"changePasswordTextField":"changePasswordTextField--06d35","changePasswordButtonIcon":"changePasswordButtonIcon--8d0b7"};